import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { CommonService } from "./common.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    console.error("Global Error Handler:", error);
    // Use lazy loading to avoid circular or premature injection
    const commonService = this.injector.get(CommonService, null);
    const router = this.injector.get(Router, null);

    const activityData = {
      activityName: "Handle Console Error",
      activityDescription: "Current Page: " + (router?.url ?? "Unknown"),
      activityData: {
        error: error?.message ?? "Unknown error",
        stack: error?.stack ?? "No stack trace",
      },
    };

    try {
      commonService?.saveActivity("Console Error", activityData);
    } catch (e) {
      console.warn("Error logging failed:", e);
    }

    // Optionally rethrow if needed
    // throw error;
  }
}
